import { render, staticRenderFns } from "./SubAlert.vue?vue&type=template&id=928b84ac&scoped=true"
import script from "./SubAlert.vue?vue&type=script&lang=js"
export * from "./SubAlert.vue?vue&type=script&lang=js"
import style0 from "./SubAlert.vue?vue&type=style&index=0&id=928b84ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b84ac",
  null
  
)

export default component.exports